import {
  FETCH_QUESTIONS,
  FETCH_QUESTIONS_SUCCESS,
  FETCH_QUESTIONS_FAILURE,
  FETCH_QUESTION,
  FETCH_QUESTION_SUCCESS,
  FETCH_QUESTION_FAILURE,
  CREATE_QUESTION,
  CREATE_QUESTION_SUCCESS,
  CREATE_QUESTION_FAILURE,
  UPDATE_QUESTION,
  UPDATE_QUESTION_SUCCESS,
  UPDATE_QUESTION_FAILURE,
  DELETE_QUESTION,
  DELETE_QUESTION_SUCCESS,
  DELETE_QUESTION_FAILURE,
  UPLOAD_QUESTIONS,
  UPLOAD_QUESTIONS_SUCCESS,
  UPLOAD_QUESTIONS_FAILURE,
  RESET_QUESTION,
  COUNT_QUESTIONS,
  COUNT_QUESTIONS_SUCCESS,
  COUNT_QUESTIONS_FAILURE,
} from "./actionTypes";

import {
  errorMetaData,
  pendingMetaData,
  successMetaData,
} from "@workspace/common";

const initialState = {
  questions: [],
  question: {},
  questionCount: null,
  createMeta: {},
  updateMeta: {},
  deleteMeta: {},
  uploadMeta: {},
};

const QuestionBankReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Questions
    case FETCH_QUESTIONS:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: action.payload,
      };
    case FETCH_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Question
    case FETCH_QUESTION:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case FETCH_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        question: action.payload,
      };

    case FETCH_QUESTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Create Question
    case CREATE_QUESTION:
      return {
        ...state,
        loading: true,
        createMeta: pendingMetaData(),
        error: false,
      };
    case CREATE_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        createMeta: successMetaData(action.payload),
        error: false,
        question: action.payload,
      };
    case CREATE_QUESTION_FAILURE:
      return {
        ...state,
        loading: false,
        createMeta: errorMetaData(action.payload),
        error: action.payload,
      };
    // Update Question
    case UPDATE_QUESTION:
      return {
        ...state,
        loading: true,
        updateMeta: pendingMetaData(),
        error: false,
      };
    case UPDATE_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        updateMeta: successMetaData(action.payload),
        question: action.payload,
        error: false,
      };
    case UPDATE_QUESTION_FAILURE:
      return {
        ...state,
        loading: false,
        updateMeta: errorMetaData(action.payload),
        error: action.payload,
      };

    // Delete Question
    case DELETE_QUESTION:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETE_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteMeta: successMetaData(action.payload),
        error: false,
      };
    case DELETE_QUESTION_FAILURE:
      return {
        ...state,
        loading: false,
        deleteMeta: errorMetaData(action.payload),
        error: action.payload,
      };
    // Upload Questions
    case UPLOAD_QUESTIONS:
      return {
        ...state,
        loading: true,
        uploadMeta: pendingMetaData(),
        error: false,
      };
    case UPLOAD_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadMeta: successMetaData(action.payload),
        error: false,
      };
    case UPLOAD_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        uploadMeta: errorMetaData(action.payload),
        error: action.payload,
      };
    // Reset Question
    case RESET_QUESTION:
      return {
        ...state,
        question: {},
      };
    // Count Questions
    case COUNT_QUESTIONS:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case COUNT_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        questionCount: action.payload,
      };
    case COUNT_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default QuestionBankReducer;
